/// <reference types="vite-plugin-svgr/client" />
import React from 'react'
import ImageSvgIcon from '../../assets/icons'
import {TooltipStyled} from '../tooltipCustom'

export type TIconName = keyof typeof ImageSvgIcon

interface IconPropsType {
  type: TIconName
  containerClass?: string
  containerStyle?: object
  iconClass?: string
  tooltip?: string
  iconStyle?: object
  size?: string
  color?: string
  tooltipPosition?: 'bottom' | 'right' | 'left' | 'top'
}

export default function Icon({
  type,
  iconClass,
  containerClass,
  containerStyle,
  size = '1rem',
  iconStyle,
  color,
  tooltip = '',
  tooltipPosition = 'bottom',
}: IconPropsType): React.JSX.Element {
  const SelectedIcon = ImageSvgIcon[type]
  const icon = SelectedIcon && (
    <SelectedIcon
      className={iconClass}
      width={size}
      height={size}
      color={color}
      style={{
        ...iconStyle,
      }}
    />
  )
  return tooltip ? (
    <TooltipStyled title={tooltip} placement={tooltipPosition}>
      <div
        className={containerClass}
        style={{
          display: 'flex',
          color: color,
          ...containerStyle,
        }}>
        {icon}
      </div>
    </TooltipStyled>
  ) : (
    <div
      className={containerClass}
      style={{
        display: 'flex',
        color: color,
        ...containerStyle,
      }}>
      {icon}
    </div>
  )
}
